import cytoscape from "cytoscape";
export default (tasks, deps) => {
  console.log("making graph");
  const _tasks = tasks.map((t) => ({
    ...t,
    dependsOn: [],
    numDeps: 0,
    orig: { ...t },
  }));
  deps.forEach((d) => {
    const t = _tasks.find((t) => t.id === d.task_id);
    if (t) {
      const dep = _tasks.find((t) => t.id === d.depends_on_id);
      if (dep && !dep.done) {
        t.dependsOn.push(dep);
        t.numDeps++;
      }
    }
  });
  const nodes = _tasks.map((t) => ({ data: { ...t }, classes: "tnode" }));
  const edges = deps
    .filter((d) => {
      const t1 = _tasks.find((t) => t.id === d.task_id);
      const t2 = _tasks.find((t) => t.id === d.depends_on_id);
      return t1 && t2;
    })
    .map((d) => ({
      data: {
        id: `${d.depends_on_id}-${d.task_id}`,
        source: d.depends_on_id,
        target: d.task_id,
        d,
      },
    }));
  const cyDoc = {
    elements: [...nodes, ...edges],
  };
  const cy = cytoscape(cyDoc);

  cy.nodes().forEach((n) => {
    const t = _tasks.find((t) => {
      return t.id === n.data().id;
    });
    if (!t) {
      return;
    }
    // debugger; // eslint-disable-line
    const cumDepentants = n.successors().filter((n) => {
      const task = tasks.find((t) => {
        return t.id === n.data().source;
      });
      return task && !task.done;
    }).length;
    t.cumDepentants = cumDepentants;
  });
  console.log({ _tasks, nodes, edges, cyDoc, cy });
  return _tasks;
};

// const getelements = function (_tasks) {
//     const elements = [];
//     elements.push(
//       ..._tasks.map((t) => ({ data: { ...t }, classes: "tnode" }))
//     );
//     elements.push(
//       ...this.deps
//         .filter((d) => {
//           const t1 = _tasks.find((t) => t.id === d.task_id);
//           const t2 = _tasks.find((t) => t.id === d.depends_on_id);
//           return t1 && t2;
//         })
//         .map((d) => ({
//           data: {
//             id: `${d.depends_on_id}-${d.task_id}`,
//             source: d.depends_on_id,
//             target: d.task_id,
//             d,
//           },
//         }))
//     );
//     // elements[0].renderedPosition = { x: 1000, y: 0 };
//     return elements;
//   },
